<template>
	<div
		id="start" class=""
		:style="computedSetHeight"
		v-show="pageReady"
	>
		<div class="flex tutorialWrapper">
			<div @click="tutorial()">
				<font-awesome-icon :icon="['fal', 'question-circle']" />
			</div>
		</div>
		<div class="logo"></div>
		<button
			class="btnStart"
			@click="login()"
		>
			<span>ログイン / アカウント作成</span>
		</button>
		<transition
			name="slide-bottom"
		>
			<ModalSlides
				v-if="showModalSlides"
				@closeModalSlides="closeModalSlides"
				contentType="tutorial"
			/>
		</transition>
	</div>
</template>

<script>
import Mixins from '@/mixins'
import ModalSlides from '@/components/ModalSlides.vue'
export default {
	name: 'start',
	mixins: [
		Mixins.buefy
	],
	components: {
		ModalSlides
	},
	data () {
		return {
			pageReady: false,
			height: 0,
			showModalSlides: false
		}
	},
	watch: {
	},
	computed: {
		computedSetHeight () {
			return `height: ${this.height}px`
		}
	},
	created () {
		if (this.$auth.isAuthenticated) {
			// this.$router.push({ name: 'Cashier' })
		}
		window.addEventListener('resize', this.handleResize)
		this.handleResize()
	},
	mounted () {
		this.$store.dispatch('Utility/dohideLoading')
		setTimeout(() => {
			this.pageReady = true
		}, 500)

		if (this.$route.query.error === 'needEmail') {
			const duration = 10 * 1000
			this.$_buefyMixin_showToast('メールアドレス使用が許可されずにログインしました。領収書送付のためにメールアドレスの使用を許可して頂き、もう一度ログインしてください。', duration, 'is-danger')
		}
	},
	destroyed () {
		window.removeEventListener('resize', this.handleResize)
	},
	methods: {
		/**
		 * ログイン
		 */
		login () {
			this.$store.dispatch('Utility/doshowLoading')
			this.$auth.loginWithRedirect()
		},
		tutorial () {
			this.showModalSlides = true
		},
		closeModalSlides () {
			this.showModalSlides = false
		},
		handleResize () {
			this.height = window.innerHeight
		}
	}
}
</script>

<style lang="stylus" scoped>
@import "~@/themes/styles/mixins.styl"

#start
	overflow scroll
	text-align center
	padding 6px
	flex-direction column
	justify-content space-between
	display flex
	background-color main-color
	.tutorialWrapper
		width 100%
		flex-direction row
		font-size 30px
		padding-left 12px
	.logo
		height 200px
		background-image url(../assets/logo_nexto_store.png)
		background-repeat no-repeat
		width 80%;
		margin 0 10%
		background-size contain
		background-position center
	.btnStart
		background-color black-color
		color #fff
		border-radius 6px
		padding 12px 6px
		> span
			font-size 16px
</style>
